import { PersonRemove } from "@mui/icons-material";
import { Box, IconButton, MenuItem, Select, SelectChangeEvent, Skeleton, TableCell, TableRow } from "@mui/material";
import { useEffect, useState } from "react";
import { KeyDriveAvatar } from "../../../../../../components/KeydriveComponents/Avatar/KeyDriveAvatar";
import { KeyDriveBodyMin } from "../../../../../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { UserGet } from "../../../../../../model/UserModel";
import { GetUser } from "../../../../../../services/UserServices";
import { PrivilegeSpec } from "../../../../UsersAndGroups/components/PrivilegesTable/PrivilegesTableUser";
import { EnumPermissionTypeNone } from "../../../../../../enums/EnumPermissionTypeNone";
import { useTranslation } from "react-i18next";
import { KeyDriveChip } from "../../../../../../components/KeydriveComponents/Tags/KeyDriveChip";
enum StatusLoading {
    loading,
    success,
    error
}
interface IUserRows {
    userId: string;
    setAllUsers?: (set: string[]) => void;
    allUsers: string[];
    allPrivileges?: PrivilegeSpec[];
    valuePrivilege?: number;
    filterName?: string;
    filterPrivilege?: string;
    hasActionIcon?: boolean,
    hasPhoneColumn?: boolean,
    hasPrivilegesColumn?: boolean
    handleChangePrivilege?: ((event: SelectChangeEvent<string>, child: React.ReactNode) => void);
    viewOnly?: boolean;
}

export function UserRows({
    userId,
    allUsers,
    allPrivileges,
    valuePrivilege,
    setAllUsers,
    filterName,
    filterPrivilege,
    hasActionIcon = true,
    hasPhoneColumn = false,
    hasPrivilegesColumn = false,
    handleChangePrivilege,
    viewOnly
}: IUserRows) {
    const [workspaceUser, setWorkspaceUser] = useState<UserGet>({} as UserGet);
    const [loading, setLoading] = useState<StatusLoading>(StatusLoading.loading);
    const { t } = useTranslation();

    function retrievePrivilegeText() : string {
        if (valuePrivilege == EnumPermissionTypeNone.commonUser) {
            return t("AdminConsole.CommonUsers")
        } else if (valuePrivilege == EnumPermissionTypeNone.read) {
            return t("AdminConsole.ReadUsers");
        } else if (valuePrivilege == EnumPermissionTypeNone.edit) {
            return t("AdminConsole.EditUsers");
        } else if (valuePrivilege == EnumPermissionTypeNone.organize) {
            return t("AdminConsole.OrganizeUsers");
        }

        return "Nenhum"
    }

    useEffect(() => {
        if (userId != undefined) {
            handleWorkspaceUser()
        }
    }, [userId])

    function handleWorkspaceUser(): void {
        GetUser(userId)
            .then(data => {
                setLoading(StatusLoading.success)
                setWorkspaceUser(data)
            }).catch((err) => setLoading(StatusLoading.error))
    }

    return (
        (loading != StatusLoading.error) ?
            <TableRow style={{ display: (filterName || filterPrivilege) ? ((filterName && workspaceUser?.name?.toUpperCase().includes(filterName!.toUpperCase())) || (filterPrivilege != undefined && valuePrivilege?.toString() == filterPrivilege)) ? 'table-row' : 'none' : 'table-row' }}>
                {
                    <TableCell sx={{ paddingRight: '8px', paddingLeft: "8px", paddingBottom: 0, paddingTop: 0 }}>
                        { viewOnly && (
                            <KeyDriveChip 
                                text={retrievePrivilegeText()}
                            />
                        ) }
                    </TableCell>
                }
                <TableCell sx={{ display: 'flex', alignItems: "center", gap: 1, paddingX: '8px', paddingY: "16px" }}>
                    {(loading == StatusLoading.success) ?
                        <KeyDriveAvatar
                            avatarType="Name"
                            avatarName={workspaceUser?.name!}
                            userImage={workspaceUser?.picture ?? ""}
                        /> :
                        <Skeleton animation="wave" variant="circular" width={26} height={26} />
                    }

                    {(loading == StatusLoading.success) ?
                        <KeyDriveBodyMin
                            color="#2D2D2D"
                            needBold
                            needEllipses={false}
                            text={workspaceUser?.name!}
                        /> :
                        <Skeleton width='100%' />
                    }
                </TableCell>
                <TableCell sx={{ paddingX: '8px', paddingY: "16px"}}>
                    {(loading == StatusLoading.success) ?
                        <KeyDriveBodyMin
                            color="#2D2D2D"
                            needBold
                            needEllipses={false}
                            text={workspaceUser?.login!}
                        /> :
                        <Skeleton />
                    }
                </TableCell>
            </TableRow>
            : <></>
    )
}